export class PasswordDto {
  newPassword: string;
  oldPassword: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/model/user/password-dto.ts